// extracted by mini-css-extract-plugin
export default {"videoWrapper":"styles_videoWrapper__49Tt-","disablevideopointer":"styles_disablevideopointer__g9YBP","video":"styles_video__rWlE6","erro":"styles_erro__xH56k"};